import { ActionButton } from '../types';

const getWearMonitoringSceneActions = (): ActionButton[] => [

];
export default getWearMonitoringSceneActions;
